import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import {
  saveActionColorType,
  saveDurationValueAfterActionColorType,
} from '@app/actions/scenes/currentSceneCreating'
import { withStyles } from '@app/components/styles'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectActionColorTypeAfterDuration
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/RoomActions/SelectActionRoomColorTypeAfterDuration/SelectActionRoomColorTypeAfterDuration'
import SelectActionColorTypeAfterDurationIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/RoomActions/SelectActionRoomColorTypeAfterDuration/SelectActionRoomColorTypeAfterDuration'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectActionColorTypeAfterDurationIOS) : withStyles(SelectActionColorTypeAfterDuration)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { stateDescription } = state.scenes.currentSceneCreating.currentAction
  const { isChangeActionMode, isChangeActionStateMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    stateDescription,
    isChangeActionMode,
    isChangeActionStateMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveActionColorType,
  saveDurationValueAfterActionColorType,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectActionColorTypeAfterDurationEnhanced = enhance

export default withRouter(SelectActionColorTypeAfterDurationEnhanced)
